<template>
  <div class="bg-white p-5 pb-1 mb-3 rounded position-relative">
    <UserTableHeader 
      :search="search"
      :download="download"
      @search="handleSearch"
      @generate-users="generateModalVisible = true"
      @disable-users="disableModalVisible = true"
    />

    <UserDataTable
      :users="users"
      :headers="headers"
      :loading="loading"
      :page="page"
      :items-per-page="itemsPerPage"
      :page-count="pageCount"
      :show-tutorial="showTutorial"
      @edit-user="editStudent"
      @page-change="handlePageChange"
      @items-per-page-change="handleItemsPerPageChange"
      @close-tutorial="markTutorialAsShowed"
      @open-tutorial-video="markTutorialAsShowed(true)"
    />

    <TutorialVideo
      v-if="openVideoModal"
      url="https://www.youtube.com/embed/TS78y_6v7bg?si=_EJfQjk5SO4w7YLi"
      @close="openVideoModal = false"
    />

    <ModalGenerateUsers
      v-if="generateModalVisible"
      :urlstudents="url"
      @reloadtable="getData"
      @close="generateModalVisible = false"
    />

    <ModalDisableUsers
      v-if="disableModalVisible"
      :urlstudents="url"
      @reloadtable="getData"
      @close="disableModalVisible = false"
    />
  </div>
</template>

<script>
import UserTableHeader from './components/UserTableHeader.vue'
import UserDataTable from './components/UserDataTable.vue'
import TutorialVideo from '../tutorials/ModalTutorial.vue'
import ModalGenerateUsers from './ModalGenerateUsers.vue'
import ModalDisableUsers from './ModalDisableUsers.vue'

export default {
  name: 'DataTableSuperadmin',
  
  components: {
    UserTableHeader,
    UserDataTable,
    TutorialVideo,
    ModalGenerateUsers,
    ModalDisableUsers
  },

  props: {
    get: { type: String, required: true },
    download: { type: String, required: true },
    trashes: { type: Boolean, default: false },
    reloadTable: { type: Boolean, default: false }
  },

  emits: ['setDataStudent'],

  data() {
    return {
      search: '',
      users: [],
      loading: false,
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      totalItems: 0,
      url: this.get,
      showTutorial: false,
      openVideoModal: false,
      generateModalVisible: false,
      disableModalVisible: false,
      searchTimeout: null,
      
      headers: [
        { text: '#', value: 'ind', align: 'center' },
        { text: 'Nombre', value: 'firstname', align: 'center' },
        { text: 'Apellido', value: 'lastname', align: 'center' },
        { text: 'Correo', value: 'email', align: 'center' },
        { text: 'Empresa', value: 'client.name', align: 'center' },
        { text: 'Rutas Inscritas', value: 'statistics.registered_routes', align: 'center' },
        { text: 'Rutas Finalizadas', value: 'statistics.routes_completed', align: 'center' },
        { text: 'Insignias Obtenidas', value: 'statistics.insignia', align: 'center' },
        { text: 'Registrado desde', value: 'created_at_convert', align: 'center' },
        { text: 'Opciones', value: 'actions', sortable: false }
      ]
    }
  },

  watch: {
    reloadTable(newVal) {
      if (newVal) this.getData()
    },
    
    page() {
      this.getData()
    },
    
    itemsPerPage() {
      this.page = 1
      this.getData()
    }
  },

  mounted() {
    this.getData()
    this.checkTutorialsShowed()
  },

  methods: {
    async getData() {
      this.loading = true
      
      try {
        const params = this.buildParams()
        const response = await axios.get(`${this.url}${params}`)
        
        this.users = response.data.data
        this.totalItems = response.data.total
        this.page = response.data.current_page
        this.pageCount = response.data.last_page
      } catch (error) {
        console.error('Error loading data:', error)
      } finally {
        this.loading = false
      }
    },

    buildParams() {
      const params = new URLSearchParams(location.search)
      const client = params.get('client')
      const course = params.get('course')
      
      let paramString = this.trashes ? '?onlyTrashes=true' : '?withUsers=true'
      
      if (client) paramString += `&idClientSelect=${client}&onlyClient=true`
      if (course) paramString += `&course=${course}`
      if (this.page) paramString += `&page=${this.page}`
      if (this.itemsPerPage) paramString += `&per_page=${this.itemsPerPage}`
      if (this.search) paramString += `&search=${this.search}`
      
      return paramString
    },

    handleSearch(searchText) {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.search = searchText
        this.page = 1
        this.getData()
      }, 400)
    },

    handlePageChange(newPage) {
      this.page = newPage
    },

    handleItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage
      this.page = 1
    },

    editStudent(user) {
      this.$emit('setDataStudent', user)
    },

    checkTutorialsShowed() {
      const tutorials = localStorage.getItem('showedtutorials')
      if (tutorials) {
        const tutorialsArray = JSON.parse(tutorials)
        this.showTutorial = !tutorialsArray.includes('users-viewusers')
      } else {
        this.showTutorial = true
      }
    },

    markTutorialAsShowed(openVideo = false) {
      const tutorials = localStorage.getItem('showedtutorials')
      const currentTutorials = tutorials ? JSON.parse(tutorials) : []
      
      localStorage.setItem('showedtutorials', 
        JSON.stringify([...currentTutorials, 'users-viewusers'])
      )
      
      this.showTutorial = false
      
      if (openVideo) {
        this.openVideoModal = true
      }
    }
  }
}
</script>